import React, { useState, useEffect, useContext } from 'react';
import {
  Box,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Typography,
  Paper,
  Menu
} from '@mui/material';
import { Divider } from '@mui/material';
import { ReactComponent as GenerateButton } from '../../../images/generateButton.svg';
import { ExpandMore } from '@mui/icons-material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate, useLocation } from 'react-router-dom';
import { validateGitCredentials, githubNewProjectCreation } from '../../../services/webServices';
import { LoadingModalContext } from '../../main-pages/ServicePage';
import { set } from 'date-fns';
import BrowsePathPopup from './BrowsePathPopup';
import { fi } from 'date-fns/locale';



function NewProjectGitCredentialsPage() {
  const [repositoryUrl, setRepositoryUrl] = React.useState('');
  const [username, setUsername] = React.useState('');
  const [token, setToken] = React.useState('');
  const [repoName, setRepoName] = React.useState('');
  const [reviewerEmail, setReviewerEmail] = React.useState('');
  const [showBranchDropdown, setShowBranchDropdown] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [projectType, setProjectType] = useState('');
  const [branches, setBranches] = useState([]);
  const [framework, setFramework] = useState("");
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [zipFile, setZipFile] = useState(null);
  const [githubpr, setGithubpr] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const {setLoadingState} = useContext(LoadingModalContext);

  useEffect(() => {
    console.log(location.state.zipFile, "gitCredentails");
    console.log(location.state, "location.state");
    setProjectType(location.state?.projectType || '');
    setFramework(location.state?.framework || '');
    setZipFile(location.state?.zipFile)
  }, [
    location.state?.projectType,
    location.state?.framework,
    location.state?.zipFile,
  ]);

  //   const handleValidateClick = async () => {

  //     setLoading(true);

  //     try {

  //       const formdata = {
  //         repositoryUrl: repositoryUrl,
  //         username: username,
  //         token: token,
  //         repoName: repoName,
  //         reviewerEmail: reviewerEmail,
  //       };
  //       console.log("Form Data: ", formdata);
  //       const response = await validateGitCredentials({ formdata });
  //       console.log("Response: ", response);
  //       console.log("Branches: ", response.data.branches);
  //       if (response.data.success === true) {
  //         console.log("Branches: ", response.data.branches);
  //         setBranches(response.data.branches);
  //         setStatusMessage("Credentials validated successfully.");

  //       }
  //     } catch (error) {
  //       console.error('Error validating credentials:', error);
  //       setStatusMessage("Error validating credentials. Please check your inputs.");
  //     } finally {
  //       setLoading(false);
  //       setShowBranchDropdown(true);
  //     }
  //   };

  const handleConfirmClick = async () => {
    // setLoading(true);
     let fake;
 
    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;
 
      const interval = setInterval(() => {
        if (stop) return;
 
        progress += 0.001;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }
 
        if (progress >= 97) progress = 97;
 
        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);
 
      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);
 
          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };
 
    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Uploading a UI Test Automation Project to GitHub",
      progress: 0,
    });
 
    fake = startProgress(setLoadingState);
    try {

      // const formdata = {
      //   username: username,
      //   token: token,
      //   repoName: repoName,
      //   zipfile :zipFile
      // };
      const formData = new FormData();
      formData.append("username", username);
      formData.append("token", token);
      formData.append("repoName", repoName);
      formData.append("zipfile", zipFile, "project.zip");
      console.log(formData, 'formData');
      const githubnewProject = await githubNewProjectCreation(formData)
      if (githubnewProject && githubnewProject.data) {
        console.log("Full GitHub response:", githubnewProject.data);
        
        // Enhance the PR details with repository name from form
        const enhancedPrDetails = {
          ...githubnewProject.data,
          repository: githubnewProject.data.repository || `${username}/${repoName}`
        };
        
        setGithubpr(enhancedPrDetails);
        console.log("PR Number:", enhancedPrDetails.pullRequestNumber);
        console.log("PR URL:", enhancedPrDetails.pullRequestUrl);
        console.log("Repository:", enhancedPrDetails.repository);
        setStatusMessage(`✅ Your repository was created successfully!`);
        await finishTo100AndClose();
      }
      console.log(githubnewProject, "githubnewProject");
      // Show popup for all successful cases
      setPopUpOpen(true);
}
catch (error) {
      console.error('Error uploading project to GitHub:', error);
      const errorMessage = error?.response?.data?.message || 
                          error?.response?.data?.Error || 
                          error?.message || 
                          'An error occurred while uploading the project to GitHub.';
      
      // Check if it's a repository name conflict
      const isRepoNameConflict = errorMessage.toLowerCase().includes('repository') && 
                                (errorMessage.toLowerCase().includes('exists') || 
                                 errorMessage.toLowerCase().includes('already') ||
                                 errorMessage.toLowerCase().includes('name'));
      
      if (isRepoNameConflict) {
        // For repository name conflicts, show a user-friendly message and allow retry
        setStatusMessage(`Repository name "${repoName}" already exists. Please choose a different name.`);
        // Don't show popup for repository name conflicts - let user modify and retry
      } else {
        // For other errors, show popup
        setStatusMessage(errorMessage);
        setPopUpOpen(true);
      }
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      setLoadingState({ open: false, message: "", progress: null });
    }
  }



  const handleClose = () => {
    setPopUpOpen(false);
  }


  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f7f4f2"
    >
      <Paper elevation={1} sx={{ p: 3, width: 500 }}>
        {/* GitHub Configuration Header */}
        <Box mb={2}>
          <Typography variant="subtitle1" fontWeight={500}>
            <ExpandMore sx={{ mr: 1, verticalAlign: 'text-bottom' }} />
            Github Configuration
          </Typography>
        </Box>

        {/* Form Fields */}
        <Box display="flex" flexDirection="column" gap={2}>
          {/* <TextField
            fullWidth
            label="Repository Url"
            placeholder="https://example.com"
            value={repositoryUrl}
            onChange={(e) => setRepositoryUrl(e.target.value)}
            variant="outlined"
          /> */}
          <TextField
            fullWidth
            label="Username"
            placeholder="Name"
            variant="outlined"
            autoComplete="new-username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            fullWidth
            label="Token"
            placeholder="Key"
            type='password'
            variant="outlined"
            autoComplete="new-password"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <TextField
            fullWidth
            label="Repo Name"
            placeholder="Repo Name"
            variant="outlined"
            value={repoName}
            onChange={(e) => setRepoName(e.target.value)}
          />
          {/* <TextField
            fullWidth
            label="Reviewer Email ID"
            placeholder="Email ID"
            variant="outlined"
            value={reviewerEmail}
            onChange={(e) => setReviewerEmail(e.target.value)}

          /> */}

          {/* <Box mt={1.5} textAlign="left">
          

              <Typography variant="subtitle1" fontWeight={500} >
                <ChevronRightIcon sx={{ mr: 1, verticalAlign: 'text-bottom' }} />
                GitHub Configuration</Typography>
            
            <Button
              variant="contained"
              sx={{ backgroundColor: '#4CAF50', color: 'white', mt: 2, textTransform: 'none' }}
              disabled={!repositoryUrl || !username || !token || !repoName}
              onClick={handleValidateClick}
            >
              Validate Credentials
            </Button>
            <Typography type= "subtitle" sx={{mt:2}}>{statusMessage}</Typography>
           
               
            
          </Box> */}
        </Box>
        
        {/* Status Message Display for Repository Name Conflicts */}
        {statusMessage && statusMessage.includes('already exists') && (
          <Box mt={2} p={2} sx={{
            backgroundColor: '#fff3cd',
            borderRadius: 1,
            border: 1,
            borderColor: '#ffeaa7',
          }}>
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#856404',
                fontWeight: 500
              }}
            >
              {statusMessage}
            </Typography>
          </Box>
        )}
        
        <Divider sx={{
          my: 1.5,
          width: '100%',
        }} />
        {/* Confirm Button */}
        <Box mt={1} textAlign="right" mb={0}>
          <Button
            startIcon={<GenerateButton />}
            variant="contained"
            sx={{ textTransform: 'none', }}
            onClick={handleConfirmClick}
            disabled={!username || !token || !repoName}
          // Disable if required fields are empty
          >
            Confirm
          </Button>
        </Box>
      </Paper>
      <BrowsePathPopup 
        open={popUpOpen} 
        handleClose={handleClose} 
        text1={statusMessage} 
        prDetails={githubpr}
      />
    </Box>
  );
}

export default NewProjectGitCredentialsPage;
